import { defineMessages } from 'react-intl';

/**
 * GitHub-specific messages for the OAuth social-proof message banner.
 */
export const messages: {
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	description: {
		id: 'oauth-banner.oauth-social-proof-message.github.description',
		defaultMessage: 'Expand your search results to include GitHub PRs, issues, and repos.',
		description:
			'Body copy of the GitHub-specific oauth social proof message. References GitHub-specific entities (PRs, issues, repos), so this key is intentionally GitHub-only.',
	},
	successFlagTitle: {
		id: 'oauth-banner.oauth-social-proof-message.github.success-flag-title',
		defaultMessage: '{product} connected',
		description:
			'Title of the success notification (flag/toast) shown after the user successfully connects their GitHub account via the oauth social proof message (e.g. "GitHub connected"). {product} is the connector display name.',
	},
	successFlagDescription: {
		id: 'oauth-banner.oauth-social-proof-message.github.success-flag-description',
		defaultMessage:
			'You can now find and action on PRs, commits, and repos in Rovo Search and Chat.',
		description:
			'Body copy of the success notification (flag/toast) shown after the user successfully connects their GitHub account via the oauth social proof message. References GitHub-specific entities (PRs, commits, repos), so this key is intentionally GitHub-only.',
	},
});
